import React, {useRef} from 'react';
import {useIsMobile} from "../../../../hooks/useIsMobile";
import {motion, useInView} from "framer-motion";
import Button from '../Button';
import {useNavigate} from "react-router-dom";

interface CardProps {
    icon: React.ReactNode;
    name: string;
    profile:  string;
    img : string;
    title: string;
    desc: string;
    index: number;
    like: string;
    isMobile?:boolean

}

const ActionCard: React.FC<CardProps> = ({ icon, name, profile, img, title, desc, index, like,isMobile}) => {

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const isSecondCard = index === 2;
   // const isMobile = useIsMobile();



    return (

        <>

        <motion.div
            ref={ref}
            initial={{opacity: 0, y: 0}}
            animate={isInView ? {opacity: 1, y: 0} : {}}
            transition={{duration: 0.5, delay: 0.4 + index * 0.2,  ease: 'easeOut', }}
            className={` w-[603px] gap-4 h-[328px] md:w-full  md:h-full  p-[35px] md:p-4  transition-transform duration-300 hover:shadow-xl hover:-translate-y-1 flex flex-col 
    ${isSecondCard ?
                'border-[#6C7B7F33] md:-ml-8 items-end justify-end' :
                'border-[#DAF5E4] md:ml-8'} 
    rounded-[24px]`}

            style={{
                background: isSecondCard
                    ? 'linear-gradient(135deg, rgba(108, 123, 127, 0.05) 0%, rgba(108, 123, 127, 0.10) 70.71%)'
                    : '#F1FBF5',
            }}

        >

            {!isMobile && (


                <div className="flex flex-row flex-grow w-full  md:h-full items-center gap-6 ">


                    <div className="flex  w-[252px] h-[250px]  flex-none">
                        <img className="w-full h-full object-cover shadow-[4px_4px_10px_rgba(0,0,0,0.10)]"
                             src={img}
                             alt="엽서 이미지"/>
                    </div>

                    <div className={"flex flex-col   md:gap-1 md:h-full gap-4"}>
                        <div className={"flex flex-row  gap-2 items-center"}>
                            <div className="flex  w-[40px] h-[40px] md:w-[25px] md:h-[25px] rounded-full">
                                <img className="w-full h-full rounded-full object-cover "
                                     src={profile}
                                     alt="작가 이미지"/>
                            </div>
                            <span className={"text-base text-[#111827] font-bold md:text-sm leading-6"}>{name}</span>
                        </div>


                        <div className={"flex w-full flex-col gap-3 md:gap-1"}>
                            <span
                                className={"text-[#111827] text-[20px] md:text-base font-medium leading-[28px] whitespace-nowrap "}>{title}</span>
                            <span
                                className={"text-[#6C7B7F] text-base md:text-xs font-normal leading-[26px]"}>{desc}</span>
                        </div>

                        <div className={"flex flex-row gap-1 items-center"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                 fill="none" className={"md:w-2 md:w-2"}>

                                <path
                                    d="M1.4875 9.38767L7.13438 14.6595C7.36875 14.8783 7.67812 15.0002 8 15.0002C8.32187 15.0002 8.63125 14.8783 8.86563 14.6595L14.5125 9.38767C15.4625 8.50329 16 7.26267 16 5.96579V5.78454C16 3.60017 14.4219 1.73767 12.2688 1.37829C10.8438 1.14079 9.39375 1.60642 8.375 2.62517L8 3.00017L7.625 2.62517C6.60625 1.60642 5.15625 1.14079 3.73125 1.37829C1.57812 1.73767 0 3.60017 0 5.78454V5.96579C0 7.26267 0.5375 8.50329 1.4875 9.38767Z"
                                    fill="#EF4444"/>
                            </svg>
                            <span
                                className={"text-[#6c7b7f] text-sm md:text-xs font-normal leading-[20px]"}>{like}</span>
                        </div>

                    </div>

                </div>


            )}



            {isMobile && (



                <div className="flex flex-row flex-grow w-full md:h-full items-center gap-6 ">


                    <div className="flex  w-[153px] h-[154px]  flex-none">
                        <img className="w-full h-full object-cover shadow-[4px_4px_10px_rgba(0,0,0,0.10)]"
                             src={img}
                             alt="엽서 이미지"/>
                    </div>

                    <div className={"flex flex-col gap-2 "}>
                        <div className={"flex flex-row  gap-2 items-center"}>
                            <div className="flex  w-[40px] h-[40px] md:w-[25px] md:h-[25px] rounded-full">
                                <img className="w-full h-full rounded-full object-cover "
                                     src={profile}
                                     alt="작가 이미지"/>
                            </div>
                            <span className={"text-base text-[#111827] font-bold md:text-sm leading-6"}>{name}</span>
                        </div>


                        <div className={"flex w-full flex-col gap-1"}>
                            <span
                                className={"text-[#111827] text-[20px] md:text-base font-medium leading-[28px] "}>{title}</span>
                            <span
                                className={"text-[#6C7B7F] text-base md:text-xs font-normal leading-[26px]"}>{desc}</span>
                        </div>

                        <div className={"flex flex-row gap-1 items-center"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                 fill="none" className={"md:w-2 md:w-2"}>

                                <path
                                    d="M1.4875 9.38767L7.13438 14.6595C7.36875 14.8783 7.67812 15.0002 8 15.0002C8.32187 15.0002 8.63125 14.8783 8.86563 14.6595L14.5125 9.38767C15.4625 8.50329 16 7.26267 16 5.96579V5.78454C16 3.60017 14.4219 1.73767 12.2688 1.37829C10.8438 1.14079 9.39375 1.60642 8.375 2.62517L8 3.00017L7.625 2.62517C6.60625 1.60642 5.15625 1.14079 3.73125 1.37829C1.57812 1.73767 0 3.60017 0 5.78454V5.96579C0 7.26267 0.5375 8.50329 1.4875 9.38767Z"
                                    fill="#EF4444"/>
                            </svg>
                            <span
                                className={"text-[#6c7b7f] text-sm md:text-xs font-normal leading-[20px]"}>{like}</span>
                        </div>

                    </div>

                </div>


            )}


        </motion.div>


        </>

    );
};


const ActionCard2: React.FC<CardProps> = ({icon, name, profile, img, title, desc, index, like}) => {


    const ref = useRef(null);
    const isInView = useInView(ref, {once: true});

    const getBorderColor = (idx: number): string => {
        switch (idx) {
            case 1:
                return 'border-[#DAF5E4]'; // 첫 번째
            case 2:
                return 'border-0'; // 두 번째
            case 3:
                return 'border-[#D4EEDF]'; // 세 번째
            default:
                return 'border-0';
        }
    };

    // 각각의 카드에 맞는 background 리턴
    const getBackgroundStyle = (idx: number): React.CSSProperties => {
        switch (idx) {
            case 1:
                return {background: '#F1FBF5'};
            case 2:
                return {
                    background:
                        'linear-gradient(135deg, #F5F5F5 0%, #E5E5E5 70.71%)',
                };
            case 3:
                return {
                    background:
                        'linear-gradient(122deg, rgba(79, 219, 149, 0.10) 5.17%, rgba(79, 219, 149, 0.20) 94.83%)',
                };
            case 4:
                return {
                    background:
                        'linear-gradient(122deg, #F5F5F5 5.17%, #FFF 94.83%)',
                };
            case 5:
                return {
                    background:
                        'linear-gradient(122deg, rgba(108, 123, 127, 0.10) 5.17%, rgba(108, 123, 127, 0.20) 94.83%)',
                };
            default:
                return {};
        }
    };


    return (

        <motion.div
            ref={ref}
            initial={{opacity: 0}}
            animate={isInView ? {opacity: 1, y: 0} : {}}
            transition={{duration: 0.5, delay: 0.4 + index * 0.2, ease: 'easeOut',}}
            className={` w-[386px] gap-4 h-[358px] p-[22px]  transition-transform duration-300 hover:shadow-xl hover:-translate-y-1 flex flex-col   rounded-[24px] border ${getBorderColor(index)}`}
            style={getBackgroundStyle(index)}

        >


            <div className="flex flex-col flex-grow  gap-6 ">
                <div className="flex justify-center items-center w-[339px] h-[156px] flex-none">
                    <img className="w-full h-full object-cover shadow-[4px_4px_10px_rgba(0,0,0,0.10)]"
                         src={img}
                         alt="엽서 이미지" />
                </div>

                <div className={"flex flex-col gap-3"}>

                    <div className={"flex flex-row justify-content-between gap-2"}>
                        <div className={"flex flex-row  gap-2 items-center"}>
                            <div className="flex  w-[40px] h-[40px] rounded-full">
                                <img className="w-full h-full rounded-full object-cover "
                                     src={profile}
                                     alt="작가 이미지" />
                            </div>
                            <span className={"text-base text-[#111827] font-bold leading-6"}>{name}</span>
                        </div>

                        <div className={"flex flex-row gap-1 items-center"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">

                                <path d="M1.4875 9.38767L7.13438 14.6595C7.36875 14.8783 7.67812 15.0002 8 15.0002C8.32187 15.0002 8.63125 14.8783 8.86563 14.6595L14.5125 9.38767C15.4625 8.50329 16 7.26267 16 5.96579V5.78454C16 3.60017 14.4219 1.73767 12.2688 1.37829C10.8438 1.14079 9.39375 1.60642 8.375 2.62517L8 3.00017L7.625 2.62517C6.60625 1.60642 5.15625 1.14079 3.73125 1.37829C1.57812 1.73767 0 3.60017 0 5.78454V5.96579C0 7.26267 0.5375 8.50329 1.4875 9.38767Z" fill="#EF4444"/>
                            </svg>
                            <span className={"text-[#6c7b7f] text-sm font-normal leading-[20px]"}>{like}</span>
                        </div>

                    </div>

                    <div className={"flex flex-col gap-3 "}>
                        <span className={"text-[#111827] text-base font-medium leading-[24px] "}>{title}</span>
                        <span className={"text-[#6C7B7F] text-sm font-normal leading-[20px]"}>{desc}</span>
                    </div>

                </div>

            </div>

        </motion.div>
    );
};


const PostCardSection: React.FC = () => {

    const isMobile = useIsMobile();
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const navigate = useNavigate();

    return (
        <section className="py-16 px-4 sm:px-6 md:px-8 flex flex-col gap-[64px] overflow-x-hidden">

            <motion.div
                ref={ref}
                className="flex flex-col gap-3 text-center"
                initial={{opacity: 0, y: 20}}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{duration: 0.6, delay: 0}}
            >
                <h2 className="text-[36px] md:text-[22px] font-extrabold  text-[#111827] leading-[28px]">
                    책과 관련된 엽서를 소개해 보세요.
                </h2>

                <motion.span
                    ref={ref}
                    className="text-[20px] md:text-base text-[#6C7B7F] md:leading-[22px] font-normal text-center"
                    initial={{opacity: 0, y: 20}}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{duration: 0.6, delay: 0.2}}
                >
                    책을 쓰면서 생긴 나의 이야기를 <br/>
                    엽서에 담아 독자에게 전할 수 있어요.
                </motion.span>
            </motion.div>

            <div className=" mx-auto flex gap-8 flex-col md:flex-col ">
                <div className="flex gap-8  md:flex-col">
                    <div className="md:self-end w-full">
                        <ActionCard
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24"
                                     fill="none">
                                    <g clipPath="url(#clip0_4962_10804)">
                                        <path
                                            d="M10.5 12C12.0913 12 13.6174 11.3679 14.7426 10.2426C15.8679 9.11742 16.5 7.5913 16.5 6C16.5 4.4087 15.8679 2.88258 14.7426 1.75736C13.6174 0.632141 12.0913 0 10.5 0C8.9087 0 7.38258 0.632141 6.25736 1.75736C5.13214 2.88258 4.5 4.4087 4.5 6C4.5 7.5913 5.13214 9.11742 6.25736 10.2426C7.38258 11.3679 8.9087 12 10.5 12ZM8.35781 14.25C3.74063 14.25 0 17.9906 0 22.6078C0 23.3766 0.623438 24 1.39219 24H15.1312C14.9859 23.5875 14.9578 23.1375 15.0656 22.6969L15.7687 19.8797C15.9 19.35 16.1719 18.8719 16.5563 18.4875L18.4453 16.5984C16.9406 15.1453 14.8969 14.25 12.6375 14.25H8.35781ZM28.7719 11.0484C28.0406 10.3172 26.8547 10.3172 26.1188 11.0484L24.7406 12.4266L28.0687 15.7547L29.4469 14.3766C30.1781 13.6453 30.1781 12.4594 29.4469 11.7234L28.7719 11.0484ZM17.6203 19.5469C17.4281 19.7391 17.2922 19.9781 17.2266 20.2453L16.5234 23.0625C16.4578 23.3203 16.5328 23.5875 16.7203 23.775C16.9078 23.9625 17.175 24.0375 17.4328 23.9719L20.25 23.2687C20.5125 23.2031 20.7563 23.0672 20.9484 22.875L27.0047 16.8141L23.6766 13.4859L17.6203 19.5469Z"
                                            fill="#19CF7A"
                                            fillOpacity="0.2"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4962_10804">
                                            <path d="M0 0H30V24H0V0Z" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            }
                            name="김소희"
                            profile={"/img/home/postcard/profile1.jpg"}
                            img={"/img/home/postcard/card1.jpeg"}
                            title="식물과 나의 하루"
                            desc={"식물을 키우면서 기다림과 돌봄의 소중함을 배웠어요. 서두르지 않는 삶의 아름다움을 함께 느껴보세요."}
                            index={1}
                            like={"89"}
                            isMobile={isMobile}
                        />
                    </div>


                    <div className="md:self-start w-full">
                        <ActionCard
                            icon={<svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24"
                                       fill="none">
                                <g clip-path="url(#clip0_4962_10821)">
                                    <path
                                        d="M5.32812 0C2.84375 0 0.828125 2.01562 0.828125 4.5V19.5C0.828125 21.9844 2.84375 24 5.32812 24H18.8281H20.3281C21.1578 24 21.8281 23.3297 21.8281 22.5C21.8281 21.6703 21.1578 21 20.3281 21V18C21.1578 18 21.8281 17.3297 21.8281 16.5V1.5C21.8281 0.670312 21.1578 0 20.3281 0H18.8281H5.32812ZM5.32812 18H17.3281V21H5.32812C4.49844 21 3.82812 20.3297 3.82812 19.5C3.82812 18.6703 4.49844 18 5.32812 18ZM6.82812 6.75C6.82812 6.3375 7.16563 6 7.57812 6H16.5781C16.9906 6 17.3281 6.3375 17.3281 6.75C17.3281 7.1625 16.9906 7.5 16.5781 7.5H7.57812C7.16563 7.5 6.82812 7.1625 6.82812 6.75ZM7.57812 9H16.5781C16.9906 9 17.3281 9.3375 17.3281 9.75C17.3281 10.1625 16.9906 10.5 16.5781 10.5H7.57812C7.16563 10.5 6.82812 10.1625 6.82812 9.75C6.82812 9.3375 7.16563 9 7.57812 9Z"
                                        fill="#6C7B7F"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_4962_10821">
                                        <path d="M0.828125 0H21.8281V24H0.828125V0Z" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>}
                            name="배예서"
                            profile={"/img/home/postcard/profile2.jpg"}
                            img={"/img/home/postcard/card2.jpeg"}
                            title="고양이가 들려주는 이야기"
                            desc={"고양이가 곁에 있어 주는 것만으로도 위로가 될 때가 있더라고요. 여러분의 곁에는 어떤 존재가 있나요?"}
                            index={2}
                            like={"127"}
                            isMobile={isMobile}
                        />
                    </div>
                </div>

                {!isMobile && (

                    <div className={"flex flex-row gap-8"}>
                        <ActionCard2
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"
                                     fill="none">
                                    <g clip-path="url(#clip0_4962_10838)">
                                        <path
                                            d="M0.65625 4.5C0.65625 2.84531 2.00156 1.5 3.65625 1.5H21.6562C23.3109 1.5 24.6562 2.84531 24.6562 4.5V19.5C24.6562 21.1547 23.3109 22.5 21.6562 22.5H3.65625C2.00156 22.5 0.65625 21.1547 0.65625 19.5V4.5ZM15.8344 9.49219C15.6234 9.18281 15.2766 9 14.9062 9C14.5359 9 14.1844 9.18281 13.9781 9.49219L9.9 15.4734L8.65781 13.9219C8.44219 13.6547 8.11875 13.5 7.78125 13.5C7.44375 13.5 7.11563 13.6547 6.90469 13.9219L3.90469 17.6719C3.63281 18.0094 3.58125 18.4734 3.76875 18.8625C3.95625 19.2516 4.35 19.5 4.78125 19.5H9.28125H10.7812H20.5312C20.9484 19.5 21.3328 19.2703 21.525 18.9C21.7172 18.5297 21.6937 18.0844 21.4594 17.7422L15.8344 9.49219ZM5.90625 9C6.50299 9 7.07528 8.76295 7.49724 8.34099C7.9192 7.91903 8.15625 7.34674 8.15625 6.75C8.15625 6.15326 7.9192 5.58097 7.49724 5.15901C7.07528 4.73705 6.50299 4.5 5.90625 4.5C5.30951 4.5 4.73722 4.73705 4.31526 5.15901C3.8933 5.58097 3.65625 6.15326 3.65625 6.75C3.65625 7.34674 3.8933 7.91903 4.31526 8.34099C4.73722 8.76295 5.30951 9 5.90625 9Z"
                                            fill="#16B96A"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4962_10838">
                                            <path d="M0.65625 0H24.6562V24H0.65625V0Z" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            }
                            name="조서하"
                            profile={"/img/home/postcard/profile3.png"}
                            img={"/img/home/postcard/card3.jpeg"}
                            title="마지막 편지"
                            desc={"편지를 쓰는 행위 자체가 사랑을 지속시키는 방법이라고 생각해요. 여러분도 소중한 사람에게 마음을 전해보세요."}
                            index={3}
                            like={"56"}
                        />


                        <ActionCard2
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"
                                     fill="none">
                                    <g clip-path="url(#clip0_4962_10838)">
                                        <path
                                            d="M0.65625 4.5C0.65625 2.84531 2.00156 1.5 3.65625 1.5H21.6562C23.3109 1.5 24.6562 2.84531 24.6562 4.5V19.5C24.6562 21.1547 23.3109 22.5 21.6562 22.5H3.65625C2.00156 22.5 0.65625 21.1547 0.65625 19.5V4.5ZM15.8344 9.49219C15.6234 9.18281 15.2766 9 14.9062 9C14.5359 9 14.1844 9.18281 13.9781 9.49219L9.9 15.4734L8.65781 13.9219C8.44219 13.6547 8.11875 13.5 7.78125 13.5C7.44375 13.5 7.11563 13.6547 6.90469 13.9219L3.90469 17.6719C3.63281 18.0094 3.58125 18.4734 3.76875 18.8625C3.95625 19.2516 4.35 19.5 4.78125 19.5H9.28125H10.7812H20.5312C20.9484 19.5 21.3328 19.2703 21.525 18.9C21.7172 18.5297 21.6937 18.0844 21.4594 17.7422L15.8344 9.49219ZM5.90625 9C6.50299 9 7.07528 8.76295 7.49724 8.34099C7.9192 7.91903 8.15625 7.34674 8.15625 6.75C8.15625 6.15326 7.9192 5.58097 7.49724 5.15901C7.07528 4.73705 6.50299 4.5 5.90625 4.5C5.30951 4.5 4.73722 4.73705 4.31526 5.15901C3.8933 5.58097 3.65625 6.15326 3.65625 6.75C3.65625 7.34674 3.8933 7.91903 4.31526 8.34099C4.73722 8.76295 5.30951 9 5.90625 9Z"
                                            fill="#16B96A"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4962_10838">
                                            <path d="M0.65625 0H24.6562V24H0.65625V0Z" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            }
                            name="정수아"
                            profile={"/img/home/postcard/profile4.jpg"}
                            img={"/img/home/postcard/card4.jpeg"}
                            title="반려동물과 잘 소통하는 법"
                            desc={"동물들의 눈을 자세히 들여다 보면 우리와 다르지 않은 감정들이 보여요."}
                            index={4}
                            like={"78"}
                        />

                        <ActionCard2
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"
                                     fill="none">
                                    <g clip-path="url(#clip0_4962_10838)">
                                        <path
                                            d="M0.65625 4.5C0.65625 2.84531 2.00156 1.5 3.65625 1.5H21.6562C23.3109 1.5 24.6562 2.84531 24.6562 4.5V19.5C24.6562 21.1547 23.3109 22.5 21.6562 22.5H3.65625C2.00156 22.5 0.65625 21.1547 0.65625 19.5V4.5ZM15.8344 9.49219C15.6234 9.18281 15.2766 9 14.9062 9C14.5359 9 14.1844 9.18281 13.9781 9.49219L9.9 15.4734L8.65781 13.9219C8.44219 13.6547 8.11875 13.5 7.78125 13.5C7.44375 13.5 7.11563 13.6547 6.90469 13.9219L3.90469 17.6719C3.63281 18.0094 3.58125 18.4734 3.76875 18.8625C3.95625 19.2516 4.35 19.5 4.78125 19.5H9.28125H10.7812H20.5312C20.9484 19.5 21.3328 19.2703 21.525 18.9C21.7172 18.5297 21.6937 18.0844 21.4594 17.7422L15.8344 9.49219ZM5.90625 9C6.50299 9 7.07528 8.76295 7.49724 8.34099C7.9192 7.91903 8.15625 7.34674 8.15625 6.75C8.15625 6.15326 7.9192 5.58097 7.49724 5.15901C7.07528 4.73705 6.50299 4.5 5.90625 4.5C5.30951 4.5 4.73722 4.73705 4.31526 5.15901C3.8933 5.58097 3.65625 6.15326 3.65625 6.75C3.65625 7.34674 3.8933 7.91903 4.31526 8.34099C4.73722 8.76295 5.30951 9 5.90625 9Z"
                                            fill="#16B96A"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4962_10838">
                                            <path d="M0.65625 0H24.6562V24H0.65625V0Z" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            }
                            name="정소라"
                            profile={"/img/home/postcard/profile5.jpg"}
                            img={"/img/home/postcard/card5.jpeg"}
                            title="계절을 걷는 마음"
                            desc={"우리 인생에도 계절이 있어요. 지금이 어떤 계절이든 그 나름의 아름다움이 있다는 걸 기억해주세요."}
                            index={5}
                            like={"92"}
                        />
                    </div>

                )}


                <div className={"flex flex-col justify-center items-center"}>
                    <Button className="border-[2px] border-main font-namsan
                         rounded-full text-main font-bold flex justify-center items-center
                          md:w-[169px]
                          h-[48px] md:h-[48px]
                          text-base md:text-sm
                          px-[43px] md:px-[32px]
                          py-4 md:py-[17px]
                          whitespace-nowrap
                          [box-shadow:0_4px_8px_0_rgba(0,128,96,0.14)]
                          "
                            onClick={() => {
                                navigate('/postcard');
                            }}
                    >
                        엽서북 살펴보기
                    </Button>
                </div>

            </div>
        </section>
    );
};

export default PostCardSection;
